var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "contenitore",
    width: 70,
    height: 70,
    transform: "translate(285 633.084)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "affidabilit\\xE0",
    transform: "translate(-104 -299.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_29",
    "data-name": "Gruppo di maschere 29",
    transform: "translate(-181 -334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fondo",
    d: "M3.371,63.393s-5.693-9.719-2.283-18.97S11,37.365,20.12,27.966C31.186,16.55,38.958,15.922,48.828,20.908c5.586,2.821,6.49,14.425,15.379,21.63,8.015,6.5,1.477,17.566-2.73,19.291a20.655,20.655,0,0,1-7.063,1.725S48.09,86.92,29.242,86.119,3.371,63.393,3.371,63.393Z",
    transform: "translate(286.1 616.06)",
    fill: "#dedbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3282",
    "data-name": "Raggruppa 3282",
    transform: "translate(23251.352 -18786.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1838",
    "data-name": "Tracciato 1838",
    d: "M205.82,221.49s.167-.017.25.654c.043.343-.557-.157-.63-.18C205.562,221.806,205.69,221.647,205.82,221.49Z",
    transform: "translate(-23145.457 19228.504)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1839",
    "data-name": "Tracciato 1839",
    d: "M343.656,151.4s4.377,5.031,4.8,17.71l-11.169,5.4-3-1.193-.145-.237.846-.522c-.51-9.844-6.291-12.4-6.291-12.4l.793-1.563Z",
    transform: "translate(-23244.805 19285)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1840",
    "data-name": "Tracciato 1840",
    d: "M312.43,209.342a38.084,38.084,0,0,0-1.918-4.449,19.092,19.092,0,0,0-3.95-5.205,1.919,1.919,0,0,0-.454-.3.493.493,0,0,0-.337-.039l4.447-2.738s5.781,2.554,6.291,12.4l-.846.522-3.258,2.007C312.845,211.236,312.757,210.387,312.43,209.342Z",
    transform: "translate(-23226.33 19248.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1841",
    "data-name": "Tracciato 1841",
    d: "M334.242,262.26c.328,1.045.415,1.895-.025,2.2a.367.367,0,0,1-.054.033c-.438.237-1.14-.846-1.332-1.16A15.711,15.711,0,0,1,334.242,262.26Z",
    transform: "translate(-23248.143 19195.641)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1842",
    "data-name": "Tracciato 1842",
    d: "M248.632,220.681a15.9,15.9,0,0,0-1.414,1.069,13.666,13.666,0,0,0-2.509,2.692l-.111.043c-.657-1.7-2.723-3.087-4.978-4.486-2.215-1.371-5.095-2.806-5.969-3.235-.169-.085-.264-.13-.264-.13-.225-.035-.427-.068-.6-.1l-.151-.025c-.458-.083-.706-.145-.706-.145l-.006.006c-.021.029-.045.058-.068.085-2.174,2.771-3.91,2.738-4.808,2.424a.637.637,0,0,1-.334-.929l2.273-3.768a2.606,2.606,0,0,1,.318-.421,2.488,2.488,0,0,1,.7-.524l4.389-2.209a3.273,3.273,0,0,1,2.2-.268l3.725.846a2.557,2.557,0,0,0,1.615-.165l.107-.05.719-.368a19.062,19.062,0,0,1,3.95,5.205A38.581,38.581,0,0,1,248.632,220.681Z",
    transform: "translate(-23162.533 19237.217)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1843",
    "data-name": "Tracciato 1843",
    d: "M204.61,239.224c.157.952.079,2.1-1.906,2.659l-.14.012a1.845,1.845,0,0,1-.343,1.3c-.543.716-1.7.6-2.1.531a1.739,1.739,0,0,1-.431,1.846c-.8.952-3.421-.469-5.4-1.761-1.28-.84-2.288-1.625-2.347-1.67-.008-2.343-1.794-3.136-2.267-2.49.014-.114-.834-2.213-1.811-2.075a.92.92,0,0,0-.751.423,1.751,1.751,0,0,0-1.486-1.274.879.879,0,0,0-1.007.667s-.355-1.253-1.212-1.21a.964.964,0,0,0-.911.609l-1.187-.578-.993-.483c.054-1.873.671-6.442,4.874-11.785.074.023.295.093.63.18a12.342,12.342,0,0,0,6.115.167l.05.169a2.524,2.524,0,0,0-.318.421l-2.273,3.768a.635.635,0,0,0,.334.929c.908.316,2.672.345,4.879-2.515,0,0,.531.13,1.458.27,0,0,3.59,1.728,6.231,3.365,2.255,1.4,4.319,2.787,4.978,4.486a3.149,3.149,0,0,1,.211.911c.161,2.127-.853,2.985-2.822,3.128Zm-.219-.778.091-.058a1.1,1.1,0,0,0-.328-1.559c-.634-.533-1.5-.6-2.915-1.5A17.077,17.077,0,0,1,204.391,238.446Z",
    transform: "translate(-23125.209 19226.527)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1844",
    "data-name": "Tracciato 1844",
    d: "M305.179,210.671l.012-.006a.493.493,0,0,1,.337.039,1.919,1.919,0,0,1,.454.3l-.719.368c-.035.017-.07.035-.107.05l-.01-.014S304.912,210.8,305.179,210.671Z",
    transform: "translate(-23225.752 19237.24)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1845",
    "data-name": "Tracciato 1845",
    d: "M291.1,284.2a1.1,1.1,0,0,1,.328,1.559l-.091.058a17.011,17.011,0,0,0-3.151-3.113C289.61,283.6,290.471,283.662,291.1,284.2Z",
    transform: "translate(-23212.16 19179.164)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1846",
    "data-name": "Tracciato 1846",
    d: "M232.273,308.186l-.006.006s-2.387,1.889-3.774,1.067a1.632,1.632,0,0,1-.514-.5,1.994,1.994,0,0,1-.18-.32c-.549-1.187-.324-3.1-.25-4.086a.639.639,0,0,1,.109-.328c.473-.648,2.261.147,2.267,2.49C229.985,306.561,230.993,307.347,232.273,308.186Z",
    transform: "translate(-23163.191 19162.146)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1847",
    "data-name": "Tracciato 1847",
    d: "M217.277,296.268a.605.605,0,0,0-.109.328c-.072.991-.3,2.9.25,4.086h0a.371.371,0,0,1-.047,0,2.067,2.067,0,0,1-2.083-.948,2.468,2.468,0,0,1-.161-.31,9.193,9.193,0,0,1-.485-2.74,4.1,4.1,0,0,1,.072-2.069.924.924,0,0,1,.751-.423C216.443,294.055,217.29,296.154,217.277,296.268Z",
    transform: "translate(-23152.809 19169.904)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1848",
    "data-name": "Tracciato 1848",
    d: "M160.021,213.25c-4.2,5.343-4.819,9.91-4.874,11.785a6.755,6.755,0,0,0,.021.908,21.506,21.506,0,0,1-4.532-1.643h0a5.648,5.648,0,0,1-.518-.324c-1.652-1.156-1.113-4.042.268-7.862a11.257,11.257,0,0,1,4.519-5.434l5.5,2.094C160.271,212.933,160.143,213.092,160.021,213.25Z",
    transform: "translate(-23100.037 19237.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1849",
    "data-name": "Tracciato 1849",
    d: "M205.067,295.908l-.047,0a2.237,2.237,0,0,1-2.628-1.681c-.021-.066-.039-.136-.054-.206a13.449,13.449,0,0,1-.211-1.961,4.554,4.554,0,0,1,.039-1.573.963.963,0,0,1,.1-.233.891.891,0,0,1,.91-.434,1.751,1.751,0,0,1,1.486,1.274,4.079,4.079,0,0,0-.072,2.069A9.067,9.067,0,0,0,205.067,295.908Z",
    transform: "translate(-23142.75 19173.422)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1850",
    "data-name": "Tracciato 1850",
    d: "M193.039,291.769l-.05,0c-2.16-.2-2.38-1.131-2.436-2.56a3.685,3.685,0,0,1,.188-1.573.968.968,0,0,1,.913-.607c.716-.035,1.08.83,1.183,1.119.019.058.029.093.029.093a4.5,4.5,0,0,0-.039,1.573A13.726,13.726,0,0,0,193.039,291.769Z",
    transform: "translate(-23133.451 19175.678)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3282-2",
    "data-name": "Raggruppa 3282",
    transform: "translate(-22940.719 19463.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1851",
    "data-name": "Tracciato 1851",
    d: "M214.967,301.1l.116.33a2.468,2.468,0,0,1-.161-.31l-.047,0a6.469,6.469,0,0,1-.392-1.722c-.037-.353-.062-.7-.1-1.016a4.081,4.081,0,0,1,.079-2.1l.041.023.043.025a4.087,4.087,0,0,0-.068,2.042c.031.318.056.663.1,1.014A5.884,5.884,0,0,0,214.967,301.1Z",
    transform: "translate(-211.886 -295.474)",
    fill: "#945f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1852",
    "data-name": "Tracciato 1852",
    d: "M227.41,305.149a15.926,15.926,0,0,0-.064,2.81,5.279,5.279,0,0,0,.446,1.592,1.992,1.992,0,0,1-.18-.32h0a.371.371,0,0,1-.047,0,4.717,4.717,0,0,1-.314-1.264,15.892,15.892,0,0,1,.064-2.828.643.643,0,0,1,.118-.351l.039.027.041.029A.556.556,0,0,0,227.41,305.149Z",
    transform: "translate(-222.283 -302.325)",
    fill: "#945f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1853",
    "data-name": "Tracciato 1853",
    d: "M202.057,295.1c.021.2.043.335.083.555a2.454,2.454,0,0,1,.043.376v.023c-.021-.066-.039-.136-.054-.206l-.05,0a6.428,6.428,0,0,1-.116-.735c-.048-.45-.06-.88-.093-1.216a4.613,4.613,0,0,1,.041-1.59l.017-.08c.019.058.029.093.029.093a.964.964,0,0,1,.1-.233,5.4,5.4,0,0,0-.087,1.8C202,294.223,202.01,294.65,202.057,295.1Z",
    transform: "translate(-201.822 -292.08)",
    fill: "#945f47"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1854",
    "data-name": "Tracciato 1854",
    d: "M90.867,169.184a11.257,11.257,0,0,0-4.519,5.434c-1.381,3.82-1.92,6.706-.268,7.862a5.931,5.931,0,0,0,.518.324l-1.625.652a6.574,6.574,0,0,1-4.691.072l-10.288-3.758C68.268,165.978,73.57,159.2,73.57,159.2l16.655,7.945C90.642,167.361,91.1,169.036,90.867,169.184Z",
    transform: "translate(-23036 19278.713)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1855",
    "data-name": "Tracciato 1855",
    d: "M181.286,285.183l-.972.425h0a6.781,6.781,0,0,1-.021-.908Z",
    transform: "translate(-23125.182 19177.551)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1856",
    "data-name": "Tracciato 1856",
    d: "M305.57,302.75",
    transform: "translate(-23226.168 19163.002)",
    fill: "#e8c8a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1857",
    "data-name": "Tracciato 1857",
    d: "M277.829,273.778l.215.176c.481.4,1.687,1.406,2.8,2.43.555.512,1.086,1.026,1.489,1.47a6.412,6.412,0,0,1,.5.6,1.355,1.355,0,0,1,.233.417c.031.145.056.308.081.465a.049.049,0,0,0,.1-.016c-.025-.161-.058-.316-.089-.46a1.57,1.57,0,0,0-.3-.541,24.619,24.619,0,0,0-2.9-2.868c-1.1-.968-2.061-1.749-2.061-1.749a.047.047,0,0,0-.068.008.047.047,0,0,0,.006.066Z",
    transform: "translate(-23203.795 19186.424)",
    fill: "#dc906d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3283",
    "data-name": "Raggruppa 3283",
    transform: "translate(-22928.441 19463.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1858",
    "data-name": "Tracciato 1858",
    d: "M270.45,292.934h0a2.55,2.55,0,0,0-.355-.343c-1.212-1.028-4.893-3.547-4.893-3.547a.049.049,0,0,0-.054.081l.207.142c.464.318,1.627,1.125,2.721,1.914.547.4,1.076.785,1.493,1.109.208.163.388.306.526.427a2.143,2.143,0,0,1,.277.273h0a2.836,2.836,0,0,1,.495,1.307l.006.07a.049.049,0,0,0,.1-.008l-.006-.072A2.947,2.947,0,0,0,270.45,292.934Z",
    transform: "translate(-265.125 -289.035)",
    fill: "#dc906d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1859",
    "data-name": "Tracciato 1859",
    d: "M265.23,289.48Z",
    transform: "translate(-265.21 -289.394)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3284",
    "data-name": "Raggruppa 3284",
    transform: "translate(-22930.512 19466.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1860",
    "data-name": "Tracciato 1860",
    d: "M258.942,308.525h0c-.71-.485-4.416-2.773-4.416-2.775a.048.048,0,1,0-.05.081l.59.365c1.074.667,3.295,2.046,3.822,2.407h0a2.468,2.468,0,0,1,.939,1.072.048.048,0,0,0,.089-.035A2.559,2.559,0,0,0,258.942,308.525Z",
    transform: "translate(-254.453 -305.743)",
    fill: "#dc906d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1861",
    "data-name": "Tracciato 1861",
    d: "M277.32,320.5Z",
    transform: "translate(-272.885 -317.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1862",
    "data-name": "Tracciato 1862",
    d: "M254.56,306.21Z",
    transform: "translate(-254.539 -306.119)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1863",
    "data-name": "Tracciato 1863",
    d: "M264.412,241.557a.048.048,0,0,1-.048.048c-1.476-.016-4.14-.37-5.1-.5-.169-.085-.264-.13-.264-.13-.225-.035-.427-.068-.6-.1.155.027.326.052.51.079a51.167,51.167,0,0,0,5.453.551A.044.044,0,0,1,264.412,241.557Z",
    transform: "translate(-23188.146 19212.873)",
    fill: "#945f47"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrust);
export default __webpack_public_path__ + "static/media/trust.cb2a68916a23b4bda2f5cbf77ebd70a3.svg";
export { ForwardRef as ReactComponent };